var webooker = webooker || {};

webooker.Wizard = function (formId, tabControlName, nextButtonName, prevButtonName, finishButtonName,
                            onActiveTabChanging, onActiveTabChanged) {

    var _formId = formId,
        _tabControlName = tabControlName,
        _nextButtonName = nextButtonName,
        _prevButtonName = prevButtonName,
        _finishButtonName = finishButtonName,
        _onActiveTabchanging = onActiveTabChanging,
        _onActiveTabchanged = onActiveTabChanged,
        _tabValidated = [];

        getForm = function () {
            return $('#' + _formId);
        },

        getTabControl = function () {
            return window[_tabControlName];
        },

        getNextButton = function () {
            return $('#' + _nextButtonName);
        },

        getPrevButton = function () {
            return $('#' + _prevButtonName);
        },

        getFinishButton = function () {
            return $('#' + _finishButtonName);
        },

        activeTabchanged = function (s, e) {
            var form = getForm();
            clearValidationSummary(form);

            if (_tabValidated[e.tab.index] === true) {
                form.validate();
                form.valid();
            }

            if (e.tab.index > 0) {
                getPrevButton().show()
            } else {
                getPrevButton().hide();
            }

            if (e.tab.index < (s.GetTabCount() - 1)) {
                getNextButton().show();
            } else {
                getNextButton().hide();
            }

            if (e.tab.index === (s.GetTabCount() - 1)) {
                getFinishButton().show();
            } else {
                getFinishButton().hide();
            }

            if (_onActiveTabchanged) {
                _onActiveTabchanged(form, e);
            }
        },

        activeTabChanging = function (s, e) {
            var form = getForm();

            // Going forward
            if (e.tab.index > s.GetActiveTabIndex()) {
                _tabValidated[s.GetActiveTabIndex()] = true;
                // validate current tab
                form.validate();
                if (form.valid()) {
                    e.tab.SetEnabled(true);
                } else {
                    disableAllTabsAfterActive();
                    e.cancel = true;
                }
            }

            if (_onActiveTabchanging) {
                _onActiveTabchanging(form, e);
            }
        },

        nextButtonClick = function () {
            var tabControl = getTabControl();
            tabControl.SetActiveTab(tabControl.GetTab(tabControl.GetActiveTabIndex() + 1));
        },

        prevButtonClick = function () {
            var tabControl = getTabControl();
            tabControl.SetActiveTabIndex(tabControl.GetActiveTabIndex() - 1);
        },

        finishButtonClick = function () {
            var form = getForm();
            form.validate();
            if (form.valid()) {
                form.submit();
            }
        },

        disableAllTabsAfterActive = function () {
            var s = getTabControl();
            for (var i = s.GetActiveTabIndex() + 1; i < s.GetTabCount() ; i++) {
                var tab = s.GetTab(i);
                tab.SetEnabled(false);
            }
        },

        clearValidationSummary = function(form) {
            form.find("[data-valmsg-summary=true]")
                .removeClass("validation-summary-errors")
                .addClass("validation-summary-valid")
                .find("ul").empty();
        },
         
        hookTabControl = function () {
            var tabControl = getTabControl();
            tabControl.ActiveTabChanged.AddHandler(activeTabchanged);
            tabControl.ActiveTabChanging.AddHandler(activeTabChanging);
        },

        hookButtons = function () {
            getNextButton().click(nextButtonClick);
            getPrevButton().click(prevButtonClick);
            getFinishButton().click(finishButtonClick);
        },


        initialize = function () {
            hookTabControl();
            hookButtons();
            disableAllTabsAfterActive();
        }

    return {
        Initialize: initialize,
    };
}